var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-title"},[(_vm.icon)?_c('img',{attrs:{"src":_vm.iconPath,"alt":_vm.title}}):_vm._e(),_c('h3',{staticClass:"icon-title__title"},[_c('strong',[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }